import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';
import SavedNotesPage from '../../../subsreens/gcstudent/savednotespage/SavedNotesPage';

const SavedNotes = () => {
    return(
        <StudentDashboardLayout>
            <SavedNotesPage></SavedNotesPage>
        </StudentDashboardLayout>
    )
}

export default SavedNotes;